import { Spinner } from '@lovoldsystem/ui'
import { useGetLovoldAsCustomer } from 'src/api/customer'
import { UsersContainer } from 'src/screens/customer/users/UsersContainer'

/**
 * A System Project Admin is any user holding ProjectPlanning Write on their (client-level) ClientUserLink to
 * Lovold AS - granted through the ordinary per-customer permissions, with Lovold AS hidden from every normal
 * customer picker. This mounts the same "manage users" screen any customer's admin uses, just pointed at
 * Lovold AS's id instead of a route param.
 */
const ProjectAdminUsers = () => {
  const { data: lovoldAs, isLoading } = useGetLovoldAsCustomer()

  if (isLoading || !lovoldAs) return <Spinner size={'small'} />

  return <UsersContainer customerId={lovoldAs.id} />
}

export default ProjectAdminUsers
